import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Button, Grid, Header, Icon } from "semantic-ui-react";
import { observer } from "mobx-react";
import TourStore from "../../../stores/TourStore";
import FormInput from "./FormInput";

@observer
class TourStatsEmail extends Component {
  addEmail = () => {
    const { tourStore } = this.props;
    tourStore.tour.addStatsEmail();
  };

  deleteStatsEmail = email => {
    const { tourStore } = this.props;
    if (tourStore.errorMessages.tour !== undefined) {
      Object.keys(tourStore.errorMessages.tour).forEach(item => {
        if (item.startsWith("statsEmailCcs")) {
          delete tourStore.errorMessages.tour[item];
        }
      });
    }
    tourStore.tour.deleteStatsEmail(email);
  };

  render() {
    const { tourStore, t } = this.props;

    return (
      <>
        <Header as="h4">
          {t("clientPanelStats:sendStatEmailsAdditional")}
          <Header.Subheader>
            <Button className="tour-stats-email-btn" onClick={this.addEmail}>
              <Icon name="add" />
              {t("clientPanelStats:addEmail")}
            </Button>
          </Header.Subheader>
        </Header>
        <Grid verticalAlign="bottom">
          {tourStore.tour.statsEmailCcs.length ? (
            tourStore.tour.statsEmailCcs.map((email, i) => {
              return (
                <Grid.Row key={["email", i].join("_")} columns={2}>
                  <Grid.Column width={12}>
                    <FormInput
                      label={t("email")}
                      name={`tour.statsEmailCcs[${i}]`}
                      errorPointing="below"
                      dataStore={tourStore}
                    />
                  </Grid.Column>

                  <Grid.Column className="tour-stats-email-delete" width={4}>
                    <Button circular icon="trash" color="red" onClick={() => this.deleteStatsEmail(email)} />
                  </Grid.Column>
                </Grid.Row>
              );
            })
          ) : (
            <Grid.Row columns={1}>
              <Grid.Column>
                <p>{t("clientPanelStats:noEmailAdded")}</p>
              </Grid.Column>
            </Grid.Row>
          )}
        </Grid>
      </>
    );
  }
}
TourStatsEmail.propTypes = {
  tourStore: PropTypes.instanceOf(TourStore),
  t: PropTypes.func.isRequired,
};

export default withTranslation()(TourStatsEmail);
